<template>
  <div class='point-data'>
    <Header :header="$t('integration.selected_monitoring_points')" />
    <el-table stripe :data='tableData' :show-header='false' :max-height='tableHeight'>
      <el-table-column prop='keycode' show-overflow-tooltip>
        <template #default='{ row, $index }'>
                    <span class='uk-text-nowrap'>
                        <i style='margin-right: 5px' v-icon="['carrierTypeConvert', row.typeId]"></i>
                        <i style='margin-right: 5px' v-icon="['carrierStatusConvert', row.status]"></i>
                        <i style='margin-right: 5px' v-icon="['isCarrierAbnormalConvert', row.abnormal]"></i>
                        <i style='margin-right: 5px' v-icon="['traceConvert', row.isTrace]"></i>

                        <el-tooltip effect='dark' :content='row.keycode'>
                            <span class='ellipsis'
                                  :class="{ bolder: activeIndex === $index, 'color-theme': activeIndex === $index }">{{
                                row.keycode
                              }}</span>
                        </el-tooltip>
                    </span>
        </template>
      </el-table-column>
      <el-table-column prop='operation' width='80px'>
        <!-- <el-table-column prop="optare" align="center"> -->
        <template #default='{ row, $index }'>
          <div class='uk-flex uk-flex-right'>
            <i class='el-icon-tickets cursor-pointer' @click='handleDetail(row)'></i>
            <i class='el-icon-close cursor-pointer' :title="$t('integration.remove')"
               @click='handleDel(row,$index)'> </i>
            <i class='el-icon-view cursor-pointer' @click='handleView(row,$index)'
               :title="$t('integration.preview')"></i>
          </div>
        </template>
        <!-- </el-table-column> -->
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import bus from '@/utils/bus'
import Header from '../../component/Header.vue'
import { carrierDetail } from '@/utils/winDetail'

export default {
  props: ['carrierList', 'condition'],
  watch: {
    carrierList (newVal) {
      this.tableData = JSON.parse(JSON.stringify(newVal))
    }
  },
  components: {
    Header
  },
  data () {
    return {
      tableHeight: 'calc(100% - 50px)',
      tableData: [],
      activeIndex: -1
    }
  },
  mounted () {
  },
  methods: {
    handleDetail (row) {
      carrierDetail(row.id, row.keycode, row.typeId)
    },
    handleDel (row, idx) {
      // this.$confirm(this.$t('integration.are_you_sure_about_this_operation?'), this.$t('public.prompt'), {
      //     confirmButtonText: this.$t('messageTitle.Yes'), // 确定按钮的文案
      //     cancelButtonText: this.$t('messageTitle.Cancel'), // 取消按钮的文案
      //     type: 'warning'
      // })
      // .then(() => {
      // 通知ChooseList删除列表 将对应的项目取消勾选
      bus.$emit('cancelSelect', row.id)
      // 在自己的列表删除
      this.$emit(
        'update:carrierList',
        this.carrierList.filter(item => item.id !== row.id)
      )
      if (this.activeIndex === idx) {
        this.activeIndex = -1
      } else {
        // if (this.activeIndex > idx) {
        //     this.activeIndex--;
        // } else {
        //     this.activeIndex++;
        // }
        this.activeIndex = true
      }
      // })
      // .catch(() => {});
    },
    handleView (row, idx) {
      this.activeIndex = idx
      this.tableData.forEach(item => this.$set(item, 'activeShow', false))
      this.$set(row, 'activeShow', true)
      bus.$emit('viewCarrierFn', row)
    }
  },
  beforeDestroy () {
    bus.$off('selectRows')
  }
}
</script>
<style lang='scss' scoped>
.point-data {
  height: calc(100% - 300px);

  .active {
    color: #344962;
  }

  .active-class {
    font-weight: bold;
  }
}
</style>
